export default "__VITE_ASSET__d3174bef__"